module.exports = __webpack_public_path__ + "img/mobile_only.3deb312d.png";